import styled from "styled-components";

import { BillingDataModalStyledProps as Props } from "./BillingDataModal.types";

const BillingDataModalStyled = styled.div<Props>`
  height: 100%;
  display: flex;
  flex-direction: column;

  .BillingDataModal {
    &__header {
      padding: 1.6rem 0rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__title {
      font-size: 1.6rem;
      font-weight: 600;
      line-height: 2.4rem;
      color: var(--palette-black-s0-l10);
    }

    &__wrapper {
      display: flex;
      padding: 0.8rem 1.6rem;
      flex: 1;
      flex-direction: column;

      .AddNewRecordButton {
        align-self: center;
        border-radius: 7.2rem;
        margin-top: 1.2rem;
        margin-bottom: 1.2rem;
      }
    }

    &__list {
      padding-top: 3.2rem;
    }
  }
`;

export default BillingDataModalStyled;
